import { faqs } from "@/mocks/editorial";

export function Faq() {
  return (
    <section id="faq" className="bg-ink-900 py-14 text-paper-50 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <p className="mb-2 text-xs font-semibold tracking-[0.2em] text-ember-400">用户问答 FAQ</p>
            <h2 className="font-display text-2xl font-black leading-snug md:text-4xl">
              关于综艺内幕，<br className="hidden md:block" />
              你最想弄明白的
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-paper-100/70">
              从台本、剪辑到考古与争议，这里汇集读者高频追问。回答力求客观，帮助你建立更完整的观看视角。
            </p>
            <a
              href="#feedback"
              className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-paper-50/25 px-6 py-3 text-sm text-paper-50 transition hover:border-ember-500 hover:bg-ember-600"
            >
              <i className="ri-chat-3-line" /> 还有疑问？留言给我们
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => (
              <details
                key={i}
                className="group rounded-xl border border-paper-50/10 bg-paper-50/[0.05] open:bg-paper-50/[0.08]"
              >
                <summary className="flex items-center justify-between gap-4 rounded-xl p-5">
                  <h3 className="font-display text-base font-bold leading-snug text-paper-50">
                    <span className="mr-3 font-black text-ember-500">Q{i + 1}.</span>
                    {f.q}
                  </h3>
                  <i className="ri-add-line shrink-0 text-lg text-ember-400 transition group-open:rotate-45" />
                </summary>
                <p className="px-5 pb-5 text-sm leading-relaxed text-paper-100/75">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function About() {
  const stats = [
    { n: "244+", label: "篇深度观察" },
    { n: "6", label: "大议题持续跟进" },
    { n: "5.2k", label: "编辑精选口碑" },
    { n: "每周", label: "稳定更新频率" },
  ];
  return (
    <section id="about" className="bg-paper-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 rounded-2xl border border-paper-200 bg-paper-50 p-6 md:p-10 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <p className="mb-2 text-xs font-semibold tracking-[0.2em] text-ember-600">关于编辑部 ABOUT US</p>
            <h2 className="font-display text-2xl font-black leading-snug text-ink-900 md:text-3xl">
              不生产「瓜」，<br />只做冷静的观察者
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-ink-600">
              大瓜观察局是一档专注综艺行业幕后与争议议题的中文媒体观察站。我们不追逐未经证实的爆料，而是以公开信息、行业常识与传播学规律为工具，帮你拆解台本、剪辑与舆论现象背后的逻辑。
            </p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-ink-700">
              <p className="flex items-start gap-3">
                <i className="ri-focus-3-line mt-0.5 text-ember-600" />
                <span><b>定位</b>：面向吃瓜用户与行业新人，把综艺运作讲得专业但不枯燥。</span>
              </p>
              <p className="flex items-start gap-3">
                <i className="ri-git-merge-line mt-0.5 text-ember-600" />
                <span><b>内容原则</b>：只基于公开信息与可验证主题，不对现实具体人物发布不实指控。</span>
              </p>
              <p className="flex items-start gap-3">
                <i className="ri-discuss-line mt-0.5 text-ember-600" />
                <span><b>开放</b>：欢迎读者就来稿主题与观看方式展开讨论。</span>
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-between gap-8">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s, i) => (
                <div key={i} className="rounded-xl border border-paper-200 bg-paper-100 p-5 text-center">
                  <p className="font-display text-2xl font-black text-ember-700">{s.n}</p>
                  <p className="mt-1 text-xs text-ink-500">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="rounded-xl border border-paper-200 bg-paper-150 p-5">
              <p className="mb-3 flex items-center gap-2 text-xs font-semibold tracking-wide text-ink-500">
                <i className="ri-chat-quote-line text-ember-600" /> 读者怎么说
              </p>
              <div className="grid gap-4 md:grid-cols-2">
                <p className="text-sm leading-relaxed text-ink-700">
                  “把‘剪辑魔法’讲得清清楚楚，看完再也不容易被带节奏了。”
                </p>
                <p className="text-sm leading-relaxed text-ink-700">
                  “干货很多但不枯燥，是吃瓜界少见的理性内容。”
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}